/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconMailAlert({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1.1953125em" height="1em" viewBox="0 0 306 256" className={className} {...props} {...attrs} data-test="IconMailAlert">  <path fill="currentColor" d="M284 62h-76v10h76V62zm-12 32h-64v10h64V94zm-15 32h-50v9h50v-9zm-12 33h-38v10h38v-10zm-14 32h-23v10h23v-10zm-28-99.4V201H24V91c1.4 1.1 89.5 65.6 89.5 65.6l89.5-65zM24 75.8V62h179v15.1l-89.5 63.6c-37.9-26-77.8-55.5-89.5-64.9z" /></svg>
  );
}

IconMailAlert.propTypes = iconPropTypes;
IconMailAlert.defaultProps = iconDefaultProps;
